import React from "react";

import { RightOutlined } from "@ant-design/icons";

import { ReactComponent as TestTubeIcon } from "../../../../../assets/icons/Sample Submission Redesign/test-tube-line.svg";

import "./ResultTestAnalyticsChart.css";

const RESULTS_COLOR = "var(--color-analytics-purple)";
const IN_PROCESS_COLOR = "var(--color-analytics-pink)";

const formatMapDisplayName = (mapName) => (
  mapName === "no_map" ? "No map" : mapName
);

const formatTooltipTitle = (entry) => {
  const contextParts = [formatMapDisplayName(entry.mapName)];

  if (entry.secondaryFieldValue != null && entry.secondaryFieldValue !== "") {
    contextParts.push(entry.secondaryFieldValue);
  }

  return `${entry.testName}: ${contextParts.join(", ")}`;
};

const formatCount = (value) => String(value).padStart(2, "0");

const ResultTestAnalyticsTooltip = ({
  active,
  payload,
  onViewDetails,
}) => {
  if (!active || !payload?.length) return null;

  const entry = payload[0]?.payload;
  if (!entry) return null;

  const handleViewDetails = (event) => {
    event.stopPropagation();
    if (onViewDetails) {
      onViewDetails(entry);
    }
  };

  return (
    <div className="ResultTestAnalyticsTooltip">
      <div className="ResultTestAnalyticsTooltip__Header">
        <span className="ResultTestAnalyticsTooltip__Title">
          {formatTooltipTitle(entry)}
        </span>
        <button
          type="button"
          className="ResultTestAnalyticsTooltip__ViewDetails"
          onClick={handleViewDetails}
        >
          Click bar to view details
          <RightOutlined />
        </button>
      </div>
      <div className="ResultTestAnalyticsTooltip__Body">
        <div className="ResultTestAnalyticsTooltip__Row">
          <div className="ResultTestAnalyticsTooltip__Pill">
            <TestTubeIcon
              className="ResultTestAnalyticsTooltip__TestTubeIcon"
              aria-hidden
            />
            <span>Total Tests Requested</span>
          </div>
          <span className="ResultTestAnalyticsTooltip__Value">
            {formatCount(entry.testsRequested)}
          </span>
        </div>
        <div className="ResultTestAnalyticsTooltip__Row">
          <div className="ResultTestAnalyticsTooltip__Pill">
            <span
              className="ResultTestAnalyticsTooltip__Dot"
              style={{ backgroundColor: RESULTS_COLOR }}
            />
            <span>Test Results available</span>
          </div>
          <span className="ResultTestAnalyticsTooltip__Value">
            {formatCount(entry.resultsAvailable)}
          </span>
        </div>
        <div className="ResultTestAnalyticsTooltip__Row">
          <div className="ResultTestAnalyticsTooltip__Pill">
            <span
              className="ResultTestAnalyticsTooltip__Dot"
              style={{ backgroundColor: IN_PROCESS_COLOR }}
            />
            <span>Tests In Process</span>
          </div>
          <span className="ResultTestAnalyticsTooltip__Value">
            {formatCount(entry.testsInProcess)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResultTestAnalyticsTooltip;
